<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      default: 5,
    },
    nameRadio: {
      type: String,
      default: 'rating',
    },
  },
  data() {
    return {
      $value: this.value,
      rating: this.value,
    };
  },
  computed: {
    ...mapGetters('app', ['isUcEnv', 'isRbEnv']),
  },
  methods: {
    star_over(index) {
      this.rating = index;
    },
    star_out() {
      this.rating = this.$data.$value;
    },
    set(index) {
      this.$data.$value = index;
    },
  },
  watch: {
    '$data.$value': function update(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<template lang="pug">
div(:class="[$style.rating, isRbEnv && $style.rb, isUcEnv && $style.uc, (isRbEnv || isUcEnv) && 'custom-ratingStars']")
  template(v-for="item in 5")
    label(
      :title="item"
      :for="`${nameRadio}-${item}`"
      :class="[$style.label, 'custom-ratingStars-label', ((item <= rating) && rating != null) && $style.isselected, ((item <= rating) && rating != null) && 'custom-ratingStars-isselected']"
      @mouseover="star_over(item)"
      @mouseout="star_out"
    )
      ui-icon(:class="[$style.ratingIco, $style.borderStar, 'custom-ratingStars-ratingIco']") star_border
      ui-icon(:class="[$style.ratingIco, $style.fullStar, 'custom-ratingStars-ratingIco']") star
    input(
      type="radio"
      :name="nameRadio"
      :value="item"
      :id="`${nameRadio}-${item}`"
      @change="set($event.target.value)"
      :class="[$style.input]"
    )
</template>

<style module lang="sass">
.rating
  display: block
  position: relative
  padding-bottom: 10px
  .input
    opacity: 0
    width: 0
    height: 0
  .label
    display: inline-block
    height: 28px
    width: 28px
    cursor: pointer
    .borderStar
      display: inline-block
    .fullStar
      display: none
    &.isselected
      .borderStar
        display: none
      .fullStar
        display: inline-block
      .ratingIco
        color: $s_color_main
  &Ico
    color: $color_bg_light_accent
    height: 28px
    width: 28px
.rb
  .label
    height: 32px
    width: 32px
    &.isselected
      .ratingIco
        color: $color_rb
  .ratingIco
    height: 24px
    width: 24px
.uc
  .label
    height: 32px
    width: 32px
    &.isselected
      .ratingIco
        color: $color_uc
  .ratingIco
    height: 24px
    width: 24px

</style>
